import Image, { ImageLoader, ImageProps } from "next/image";
import { ReactNode } from "react";

const contentfulLoader: ImageLoader = ({ src, width, quality }) =>
  `${src}?w=${width}&q=${quality || 75}`;

export function ContentfulImage({ alt, ...props }: ImageProps): ReactNode {
  return <Image loader={contentfulLoader} alt={alt} {...props} />;
}
